import React from 'react'
import Link from 'next/link'
import styles from './ShutdownHome.module.css'

const ShutdownHome = () => {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.noticeCard}>
          <div className={styles.iconWrapper}>
            <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="#60a5fa" strokeWidth="2"/>
              <path d="M12 8V12" stroke="#60a5fa" strokeWidth="2" strokeLinecap="round"/>
              <circle cx="12" cy="16" r="1" fill="#60a5fa"/>
            </svg>
          </div>

          <h1 className={styles.title}>Mnemonic Recovery</h1>

          <p className={styles.description}>
            The Relysia platform has shut down. Thank you for being part of our journey.
            Your keys remain yours — export them and continue using them anywhere.
          </p>

          <div className={styles.infoSection}>
            <h2>Export Your Keys</h2>
            <p>
              Log in to retrieve your wallet recovery phrase (mnemonic) and derivation path.
              You can import these into any compatible BSV wallet to continue managing your funds.
            </p>
          </div>

          <div className={styles.actionSection}>
            <Link href="/auth/login">
              <a className={styles.primaryBtn}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M15 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M10 17L15 12L10 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M15 12H3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                Log In to Retrieve Your Keys
              </a>
            </Link>
          </div>

          <div className={styles.helpSection}>
            <h3>Important Information</h3>
            <ul>
              <li>Your funds are safe and can be recovered using your mnemonic phrase</li>
              <li>The derivation path used is: <code>m/44'/0'/0'/0/pathIndex</code></li>
              <li>You can import your mnemonic into any compatible BSV wallet</li>
              <li>Make sure to store your recovery phrase securely offline</li>
            </ul>
          </div>
        </div>

        <div className={styles.supportSection}>
          <p>
            Questions? Contact us at{' '}
            <a href="mailto:one@vaionex.com">one@vaionex.com</a>
          </p>
          <p className={styles.copyright}>
            Thank you for using Relysia.
          </p>
        </div>
      </div>
    </div>
  )
}

export default ShutdownHome
